import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import logo from "../../assets/investteklogo.png";
import { useAuth } from "../../Context/AuthContext";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const roleName = sessionStorage.getItem("roleName");
  const { email } = useAuth();
  const firstLetter = email ? email.charAt(0).toUpperCase() : "";

  useEffect(() => {
    // Retrieve first name and last name from session storage
    const storedFirstName = sessionStorage.getItem("firstname") || "";
    const storedLastName = sessionStorage.getItem("lastname") || "";

    // Update state with retrieved values
    setFirstName(storedFirstName);
    setLastName(storedLastName);
  }, []);

  useEffect(() => {
    // Update state when the values change in session storage
    const handleStorageChange = (event) => {
      if (event.key === "firstname") {
        setFirstName(event.newValue || "");
      } else if (event.key === "lastname") {
        setLastName(event.newValue || "");
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      // Clean up the event listener when the component is unmounted
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleEmailClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    // Implement your logout logic here
    // For example, redirecting to the logout page or calling a logout function
    console.log("Logout clicked");
    handleClose();
    navigate("/signin");
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          height: "60px",
          backgroundColor: "#223D6C",
          color: "white",
          padding: "15px",
        }}
      >
        <Box>
          {/* <img src={logo} alt="Logo" width={"100px"} /> */}
          Amigo
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box>
            <Avatar
              onClick={handleEmailClick}
              sx={{
                width: "25px",
                height: "25px",
                marginRight: "3px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              {firstLetter}
            </Avatar>
          </Box>
          <Box>
            {`${firstName} ${lastName}`}
            <Box sx={{ fontSize: 13 }}>{roleName}</Box>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
            {/* Add more menu items as needed */}
          </Menu>
        </Box>
      </div>
    </div>
  );
};

export default Header;
